var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBothShadow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.3%",
    y: "-13.3%",
    width: "146.7%",
    height: "146.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pizzatoppings",
    transform: "translate(-130.000000, -111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Both",
    transform: "translate(134.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#774518",
    strokeWidth: 2,
    fill: "#B93131",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14,4 L14,26 C7.92486775,26 3,21.0751322 3,15 C3,8.92486775 7.92486775,4 14,4 Z",
    id: "Combined-Shape-Copy",
    fill: "#DDCC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,4 L27,26 C20.9248678,26 16,21.0751322 16,15 C16,8.92486775 20.9248678,4 27,4 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#DDCC4E",
    transform: "translate(21.500000, 15.000000) scale(-1, 1) translate(-21.500000, -15.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBothShadow);
export default __webpack_public_path__ + "static/media/BothShadow.6cc9690bfc00adfcc14c88a6e89d2e7c.svg";
export { ForwardRef as ReactComponent };